import Player from "../player";

export default class LocalPlayer extends Player {

    isLocal(): boolean {
        return true
    }
}